import type { JSX } from 'react';

import Spacing from './Spacing';

type PaddingSize = 'none' | 'nano' | 'tiny' | 'small' | 'medium' | 'large';

export interface PaddingProps {
    size?: PaddingSize;
    spacing?: number;
}

const paddingMultiplier = (size: PaddingSize | undefined): number | undefined => {
    if (size === undefined) {
        return undefined;
    }

    return size === 'none'
        ? 0
        : size === 'nano'
          ? 0.5
          : size === 'tiny'
            ? 1
            : size === 'small'
              ? 2
              : size === 'medium'
                ? 3
                : 6;
};

const Padding = ({ size, spacing = 1 }: PaddingProps): JSX.Element => {
    return (
        <div
            style={{
                height: Spacing(paddingMultiplier(size) || spacing),
                width: Spacing(paddingMultiplier(size) || spacing),
                flexShrink: 0,
            }}
        />
    );
};

export default Padding;
